export default "__VITE_ASSET__CYye68ND__"